import { observable, action, makeObservable } from 'mobx';
import Suggestion from './suggestion';
import {
  getGeoIdFromQsMethods,
  getGeoTypeIdFromQsMethods,
} from '../utils/uiQueryString';
import { paramsDefaults } from '../constants/uiParams';
import { hasValue } from '../utils';

class GeoStore {
  suggestions = [];
  selectedSuggestion = null;
  geoTypeId = null;
  geoId = null;

  constructor() {
    makeObservable(this, {
      suggestions: observable,
      selectedSuggestion: observable,
      geoTypeId: observable,
      geoId: observable,
      setSelectedSuggestion: action,
      setGeoTypeId: action,
      setGeoId: action,
      clearSuggestions: action,
      resetStore: action,
    });

    this.selectedSuggestion = new Suggestion();
    this.setGeoFromQs();
  }

  setGeoFromQs = () => {
    this.setGeoTypeIdFromQs();
    this.setGeoIdFromQs();
  }

  setSelectedSuggestionFromQs = (response) => {
    const dataIsValid = response
      && response.locationName
      && this.useGeoFromUrlParams;

    if (dataIsValid) {
      const { locationName } = response;

      const suggestion = {
        id: this.geoId,
        type: this.geoTypeId,
        text: locationName,
      };

      this.setSelectedSuggestion(suggestion);
    }

    this.resetGeoParams();
  }

  setGeoTypeIdFromQs = () => {
    const { value, clear } = getGeoTypeIdFromQsMethods();

    this.setGeoTypeId(value);
    clear();
  }

  setGeoIdFromQs = () => {
    const { value, clear } = getGeoIdFromQsMethods();

    this.setGeoId(value);
    clear();
  }

  setGeoTypeId = (geoTypeId) => {
    this.geoTypeId = geoTypeId;
  }

  setGeoId = (geoId) => {
    this.geoId = geoId;
  }

  setSelectedSuggestion = (suggestion) => {
    this.selectedSuggestion.setSuggestion(suggestion);
  };

  resetStore = () => {
    this.setSelectedSuggestion({
      text: paramsDefaults.GeoName,
      type: paramsDefaults.GeoTypeId,
      id: paramsDefaults.GeoId,
    });
    this.suggestions = [];
  }

  clearSuggestions = () => {
    this.suggestions = [];
    this.selectedSuggestion = new Suggestion();
  }

  resetGeoParams = () => {
    this.setGeoTypeId(null);
    this.setGeoId(null);
  }

  get useGeoFromUrlParams() {
    return hasValue(this.geoTypeId) && hasValue(this.geoId);
  }

  get geoContext() {
    if (this.useGeoFromUrlParams) {
      return {
        geoTypeId: this.geoTypeId,
        geoId: this.geoId,
        withLocationName: true,
      };
    }

    if (!this.selectedSuggestion) {
      return {};
    }

    const {
      type,
      id,
    } = this.selectedSuggestion;

    return {
      geoTypeId: type,
      geoId: id,
    };
  }
}

export default GeoStore;
